<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<style>
.container{
  display: flex;
}

device-container{
  flex-wrap: wrap;
}
.breadcrumb {
  justify-content: flex-start;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  margin-left: 10px;
}

.breadcrumb-link {
  color: #AC242A;
  text-decoration: none;
}
.device-search-container{
  padding: 10px;
}

.search-bar input[type="text"] {
  padding: 10px;
  font-size: 16px;
  width: 650px;
  height: 30px;
  margin-right: -45px;
  margin-bottom: 20px;
  margin-top: 10px;
}

@media screen and (min-width: 1530px) and (max-width: 1750px) {
  .search-bar input[type="text"] {
    width: 500px;
  }
}
@media screen and (min-width:1197px) and (max-width: 1529px){
  .search-bar input[type="text"] {
    width: 450px;
  }
}
@media screen and (min-width:1114px) and (max-width:1196px){
  .search-bar input[type="text"] {
    width: 400px;
  }
}
@media screen and (min-width:1030px) and (max-width:1113px)  {
  .search-bar input[type="text"] {
    width: 350px;
  }
}

@media screen and (min-width:947px) and (max-width:1029px) {
  .search-bar input[type="text"] {
    width: 200px;
  }
}

@media screen and (max-width:946px) {
  .search-bar input[type="text"] {
    width: 200px;
  }
}

.search-bar input[type="text"]:focus {
  outline: none;
  border: 2px solid #AC242A;
}

.search-bar input::placeholder {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: grey;
}


.search-icon {
  color: white;
  background-color: #AC242A;
  padding: 12px;
  margin-bottom: 20px;
  margin-top: 10px;
}

.device-list-div{
  display:flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  width: 1300px;
  margin-left: -380px;
}

@media screen and (min-width: 1450px) {
  .device-list-div {
    width: 1700px;
    margin-left: -500px;
  }
}

@media screen and (min-width: 1530px) and (max-width: 1750px) {
  .device-list-div {
    width: 1300px;
    margin-left: -350px;
  }
}
@media screen and (min-width:1197px) and (max-width: 1529px){
  .device-list-div {
    width: 1000px;
    margin-left: -250px;
  }
}
@media screen and (min-width:1114px) and (max-width:1196px){
  .device-list-div {
    width: 800px;
    margin-left: -200px;
  }
}
@media screen and (min-width:1030px) and (max-width:1113px)  {
  .device-list-div{
    width: 600px;
    margin-left: -150px;
  }
}

@media screen and (min-width:947px) and (max-width:1029px) {
  .device-list-div {
    width: 400px;
    margin-left: -100px;
  }
}

@media screen and (max-width:946px) {
  .device-list-div{
    width: 200px;
    margin-left: -50px;
  }
}
@media screen and (min-width:300px) and (max-width:945px) {
  .device-list-div {
    width: 100px;
    margin-left: 100px;
  }
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}

.table th,
.table td {
  padding: 15px;
  text-align: left;
}

.table thead th {
  background-color: #f2f2f2;
  color: #333;
  font-weight: bold;
  font-size: 16px;
}

.table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.table tbody tr:hover {
  background-color: #ddd;
}

.full-width {
  width: 95%;
}

a{
  cursor: pointer;
}

.no-data-message{
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 50px;
  margin-left: -450px;
}

  mat-form-field {
    --mdc-outlined-text-field-focus-outline-color: #AC242A;
    --mat-select-focused-arrow-color: #AC242A;
    width: 150px;
    margin-top: 10px;
    padding: 5px;
  }
  
  mat-form-field mat-select {
    font-size: 16px; 
    font-family: Arial, Helvetica, sans-serif;
  }

  .horizontal-line{
  width: 1300px;
  margin-left: -380px;
  margin-bottom: 20px;
}

@media screen and (min-width: 1450px) {
  .horizontal-line {
    width: 1700px;
    margin-left: -500px;
  }
}

@media screen and (min-width: 1530px) and (max-width: 1750px) {
  .horizontal-line {
    width: 1450px;
    margin-left: -450px;
  }
}
@media screen and (min-width:1197px) and (max-width: 1529px){
  .horizontal-line {
    width: 1150px;
    margin-left: -350px;
  }
}
@media screen and (min-width:1114px) and (max-width:1196px){
  .horizontal-line {
    width: 1000px;
    margin-left: -350px;
  }
}
@media screen and (min-width:1030px) and (max-width:1113px)  {
  .horizontal-line {
    width: 900px;
    margin-left: -250px;
  }
}

@media screen and (min-width:947px) and (max-width:1029px) {
  .horizontal-line {
    width: 800px;
    margin-left: -250px;
  }
}

@media screen and (max-width:946px) {
  .horizontal-line {
    width: 500px;
    margin-left: -250px;
  }
}
@media screen and (min-width:300px) and (max-width:945px) {
  .horizontal-line {
    width: 500px;
    margin-left: -150px;
  }
}

.mat-button-prev{
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  margin: 10px;
  font-size: 16px;
}

</style>

<div class="container" fxLayout="column">
  <div fxLayout="row" class="device-container">
    <!-- <div class="breadcrumb">
      <p>
        <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
        <span>Devices</span> 
      </p>
    </div>  -->
  <div fxLayout="row wrap" class="device-search-container" fxLayoutGap="10">
      <mat-form-field appearance="outline" class="mat-form-field">
        <mat-select placeholder="Serial No." [(ngModel)]="filter" (selectionChange)="onFilterChange()" [disabled]="true">
        </mat-select>
      </mat-form-field>

      <div class="search-bar" fxLayout="row" fxLayoutAlign="start center">
        <input id="search_field" #search_field type="text" placeholder="Search" [(ngModel)]="q" appEnterKey (enterKey)="searchDevices(q)" trim>
        <span class="search-icon" (click)="searchDevices(q)"><i class="fas fa-search"></i></span>
      </div>
          <!-- <mat-form-field appearance="outline">
              <mat-select placeholder="Model" [(ngModel)]="model" (ngModelChange)="onModelChange()">
                <mat-option value="wifidetector">WifiDetector</mat-option>
                <mat-option value="waterleakdetector">Water Leak Detector</mat-option>
                <mat-option value="detector">Detector</mat-option>
                <mat-option value="cowifidetector">CO Wifi Detector</mat-option>
                <mat-option value="wifiiaqdetector">WiFi IAQ Detector</mat-option>
                
              </mat-select>
            </mat-form-field> -->

</div>
</div>
</div>

  

    <!-- <div class="device-list-div" *ngIf="rowData && rowData.length > 0">
        <ag-grid-angular
            style="width: 100%; height: 55vh;"
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowData]="rowData"
            [rowSelection]="'multiple'"
            [animateRows]="true"
            [enableBrowserTooltips]="true" 
        ></ag-grid-angular>
    </div>  -->

    <!-- <div fxLayout="row" >
      <div class="pagination-controls" fxFlex="100">
          <div class="pagination">
              <button class="mat-button-prev" mat-raised-button (click)="goToPage(1)" [disabled]="currentPage === 1 || !rowData.length ">First</button>
              <button class="mat-button-prev" mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
              <span class="page-button">Page {{ currentPage }} </span>
              <button class="mat-button-prev" mat-raised-button (click)="nextPage()" [disabled]="currentPage === totalPages || !rowData.length">Next</button>
              <button class="mat-button-prev" mat-raised-button (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages || !rowData.length">Last</button>
          </div>
    
            <div class="items">
              <mat-form-field appearance="outline">
                <mat-select placeholder="{{ defaultPlaceholder }}" [(value)]="pageSize" (selectionChange)="onPageSizeChange($event)">
                  <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} items per page</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
        </div>
   </div> -->

   <hr class="horizontal-line">

   <div *ngIf="dataFetched && rowData && rowData.length === 0" class="no-data-message">
    No Record Found
  </div>

   <div class="device-list-div" *ngIf="dataFetched && rowData && rowData.length > 0">
    <table class="table full-width">
      <thead>
        <tr>
          <th>ID</th>
          <th>Serial</th>
          <th>Device Name</th>
          <th>Location</th>
          <th>Model</th>
          <th>Firmware Details</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of rowData">
          <td>
            <a (click)="navigateToDeviceDetails(item.id, item.location_id)">
              {{ item.id }}
            </a>
          </td>
          <td>{{ item.serialnumber }}</td>
          <td>{{ item.label }}</td>
          <td>
            <ng-container *ngIf="item.location_id">
              <a (click)="navigateToLocationDetails(item.location_id)">
                {{ item.location_id }}
              </a>
            </ng-container>
          </td>
          <td>{{ item.model }}</td>
          <td>
            {{"{ wm: " + (item.fwrev?.wm || item.fwmm || item.fw_wm || '') + ", net: " + 
              (item.fwrev?.net || item.fwnet || item.fw_net || '') + ", alarm: " + 
              (item.fwrev?.alarm || item.fwmb || item.fw_alarm || item.fw_mb || '') + "}"
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination"  *ngIf="filter === 'serial' && dataFetched && rowData.length > 0">
    <button  class="mat-button-prev" mat-raised-button (click)="goToPage(1)" [disabled]="currentPage === 1 || !rowData.length">First </button>
    <button  class="mat-button-prev" mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1"><</button>
    <span class="page-button">Page {{ currentPage }} of {{ totalPages }}</span>
    <button  class="mat-button-prev" mat-raised-button (click)="nextPage()" [disabled]="currentPage === totalPages || !rowData.length">></button>
    <button class="mat-button-prev" mat-raised-button (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages || !rowData.length">Last</button>
  </div>
  
  

